import { FC } from 'react';
import { IconProps, IconColor } from '../types';

export const TimerIcon: FC<IconProps> = ({
  width = 20,
  height = 20,
  fillColor = IconColor.GREEN,
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.5 2.50004V0.833374H12.5V2.50004H7.5ZM9.16667 11.6667H10.8333V6.66671H9.16667V11.6667ZM10 18.3334C8.97222 18.3334 8.00347 18.1355 7.09375 17.7396C6.18403 17.3438 5.38889 16.8056 4.70833 16.125C4.02778 15.4445 3.48958 14.6493 3.09375 13.7396C2.69792 12.8299 2.5 11.8612 2.5 10.8334C2.5 9.8056 2.69792 8.83685 3.09375 7.92712C3.48958 7.0174 4.02778 6.22226 4.70833 5.54171C5.38889 4.86115 6.18403 4.32296 7.09375 3.92712C8.00347 3.53129 8.97222 3.33337 10 3.33337C10.8611 3.33337 11.6875 3.47226 12.4792 3.75004C13.2708 4.02782 14.0139 4.4306 14.7083 4.95837L15.875 3.79171L17.0417 4.95837L15.875 6.12504C16.4028 6.81949 16.8056 7.56254 17.0833 8.35421C17.3611 9.14587 17.5 9.97226 17.5 10.8334C17.5 11.8612 17.3021 12.8299 16.9062 13.7396C16.5104 14.6493 15.9722 15.4445 15.2917 16.125C14.6111 16.8056 13.816 17.3438 12.9062 17.7396C11.9965 18.1355 11.0278 18.3334 10 18.3334ZM10 16.6667C11.6111 16.6667 12.9861 16.0973 14.125 14.9584C15.2639 13.8195 15.8333 12.4445 15.8333 10.8334C15.8333 9.22226 15.2639 7.84726 14.125 6.70837C12.9861 5.56949 11.6111 5.00004 10 5.00004C8.38889 5.00004 7.01389 5.56949 5.875 6.70837C4.73611 7.84726 4.16667 9.22226 4.16667 10.8334C4.16667 12.4445 4.73611 13.8195 5.875 14.9584C7.01389 16.0973 8.38889 16.6667 10 16.6667Z"
        fill={fillColor}
      />
    </svg>
  );
};
